// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { TableCellLayout } from '@fluentui/react-components';
import React, { useMemo } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { timeSince } from '../../utilities/time';
import { IntlProps } from '../common';

// Last Published cell properties.
export type LastPublishedCellProps = IntlProps<{
    lastPublished?: Date;
}>;

// Last Published data grid cell contents.
export default injectIntl((props: LastPublishedCellProps) => {
    const { intl, lastPublished } = props;

    const lastPublishedText = useMemo(() => {
        if (lastPublished !== undefined) {
            return timeSince(lastPublished.getTime(), intl);
        } else {
            return <FormattedMessage defaultMessage="Not published" description="Not published" />;
        }
    }, [lastPublished, intl]);

    return <TableCellLayout>{lastPublishedText}</TableCellLayout>;
});
